import { createFileRoute } from "@tanstack/react-router";

import CompetitionRouteSidebar from "@/components/CompetitionRoutes/CompetitionRouteSidebar";

const Component = () => {
  const { routeUuid } = Route.useParams();
  return <CompetitionRouteSidebar routeUuid={routeUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid/routes/$routeUuid")({
  component: Component,
});
